// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__zb8RQ","Logo":"Header_Logo__XVN9D","Main__nav":"Header_Main__nav__3aAO4","active":"Header_active__UEJuF"};